<template>
	<div>
		<svg :class="svgClass" aria-hidden="true" v-on="$listeners">
			<use :xlink:href="iconName" />
		</svg>
	</div>
</template>

<script>
	export default {
		name: 'SvgIcon',
		components: {},
		props: {
			iconClass: {
				type: String,
				required: true,
			},
			className: {
				type: String,
				default: '',
			},
		},
		data() {
			return {};
		},
		computed: {
			iconName() {
				return `#icon-${this.iconClass}`;
			},
			svgClass() {
				if (this.className) {
					return 'svg-icon ' + this.className;
				} else {
					return 'svg-icon';
				}
			},
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {},
	};
</script>

<style scoped>
	.svg-icon {
		width: 100%;
		height: 0.2rem;
		/* vertical-align: -0.15rem; */
		fill: currentColor;
		overflow: hidden;
		/* margin-left:0rem; */
		/* padding-right: .2rem; */
		position: relative;
		right: 0.06rem;
		margin-top: 0.075rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/game/common-component/svg-icon/index.vue